import React, {useEffect, useMemo} from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styles from './CreateFormPage.module.css';
import FormBuilder from '../../components/FormBuilder/FormBuilder';
import Title from "../../components/common/Title/Title";
import {FormattedMessage} from "react-intl";
import {showBackButton} from "../../services/telegramService";

let tempIdCounter = 0;
const getTempId = () => `temp-${tempIdCounter++}`;

// Функция для подготовки шаблона: добавляет уникальные временные ID
const prepareTemplate = (templateContent) => {
    if (!templateContent) return null;

    // Глубокое копирование, чтобы не изменять оригинальный объект из location.state
    const newForm = JSON.parse(JSON.stringify(templateContent));

    newForm.questions = newForm.questions.map(question => ({
        ...question,
        // Генерируем новый временный ID для вопроса
        temp_id: getTempId(),
        id: undefined, // Убираем ID шаблона, если он был
        options: question.options ? question.options.map(option => ({
            ...option,
            // Генерируем новый временный ID для опции
            temp_id: getTempId(),
            id: undefined, // Убираем ID шаблона, если он был
        })) : []
    }));

    return newForm;
};

const CreateFormPage = () => {

    const location = useLocation();
    const intl = useIntl();

    useEffect(() => {
        showBackButton();
    }, []);

    // const initialData = location.state?.initialForm || null;
    // const pageTitle = initialData
    //     ? intl.formatMessage({ id: "editFormPage.title" }) // "Редактирование формы"
    //     : intl.formatMessage({ id: "create.newPageTitle" }); // "Создать форму"

    const templateContent = location.state?.template?.content || null;

    // 2. С помощью useMemo подготавливаем initialForm для FormBuilder.
    // Этот код выполнится только один раз или когда изменится шаблон.
    const initialDataForBuilder = useMemo(() => {
        if (templateContent) {
            // Если есть шаблон, подготавливаем его (добавляем temp_id)
            return prepareTemplate(templateContent);
        }
        // Если шаблона нет (создание с чистого листа), передаем null.
        // FormBuilder сам установит значения по умолчанию.
        return null;
    }, [templateContent]);


    return (
        <div className={styles.pageWrapper}>
            {/*<Title>{pageTitle}</Title>*/}
            <Title><FormattedMessage id="create.newPageTitle" /></Title>
            <FormBuilder initialForm={initialDataForBuilder} />
        </div>
    );
};

export default CreateFormPage;
